/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * Stands in for a calendar until the gym's zone is known, so no day is drawn on the wrong clock.
 */
import React from "react";
import { Skeleton } from "@lemonadetraining/web-ui";

interface GymCalendarSkeletonProps {
  tiles?: number;
  className?: string;
  tileClassName?: string;
  testId?: string;
}

const GymCalendarSkeleton: React.FC<GymCalendarSkeletonProps> = ({
  tiles = 1,
  className,
  tileClassName,
  testId,
}) => (
  <div className={className} data-testid={testId}>
    <span className="sr-only" role="status">
      Loading the gym&apos;s calendar
    </span>
    {Array.from({ length: tiles }, (_, i) => (
      <Skeleton key={i} className={tileClassName} />
    ))}
  </div>
);

export default GymCalendarSkeleton;
